import { FieldControl } from '@/shared/components/ui/field-control';
import {
  formErrorClassName,
  formFieldGapClassName,
  formHelperClassName,
  formLabelClassName,
  formRequiredMarkClassName,
} from '@/shared/components/ui/form-control-styles';
import { Label } from '@/shared/components/ui/label';
import { cn } from '@/shared/lib/utils';
import * as React from 'react';

interface FieldProps {
  label?: React.ReactNode;
  htmlFor?: string;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * Label + control + hint/error 래퍼.
 * RDS Input 스펙: gap 4px, Label 15px, Helper 14px.
 */
export const Field: React.FC<FieldProps> = ({
  label,
  htmlFor,
  hint,
  error,
  required,
  className,
  children,
}) => (
  <div
    className={cn('group', formFieldGapClassName, className)}
    data-invalid={error ? true : undefined}
  >
    {label ? (
      <Label
        htmlFor={htmlFor}
        className={cn(formLabelClassName, error && 'text-[#d93e39]')}
      >
        {label}
        {required ? (
          <span className={formRequiredMarkClassName} aria-hidden="true">
            *
          </span>
        ) : null}
      </Label>
    ) : null}
    <FieldControl>{children}</FieldControl>
    {hint && !error ? <p className={formHelperClassName}>{hint}</p> : null}
    {error ? <p className={formErrorClassName}>{error}</p> : null}
  </div>
);
